import { render, staticRenderFns } from "./TrainingFolders.vue?vue&type=template&id=7c4cca9b&scoped=true&"
import script from "./TrainingFolders.vue?vue&type=script&lang=js&"
export * from "./TrainingFolders.vue?vue&type=script&lang=js&"
import style0 from "./TrainingFolders.vue?vue&type=style&index=0&id=7c4cca9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4cca9b",
  null
  
)

export default component.exports